export class GoogleAnalyticsService {
  public static loadJs(trackId: string) {
    try {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackId;

      script.onload = () => {
        this.grabGtag();
        window['gtag']('js', new Date());
        window['gtag']('config', trackId);
      };

      document.head.appendChild(script);
    } catch (error) {
      console.error('Google Analytics loadJs error', error);
    }
  }

  public static grabGtag() {
    window['dataLayer'] = window['dataLayer'] || [];
    if (!window['gtag']) {
      window['gtag'] = function () {
        window['dataLayer'].push(arguments);
      };
    }
  }

  // wait 3 seconds to make sure the script is loaded
  public static checkScriptLoaded(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.isScriptExist()) {
        resolve(true);
      } else {
        setTimeout(() => {
          resolve(this.isScriptExist());
        }, 3000);
      }
    });
  }

  public static async trackPageView() {
    try {
      if ((await this.checkScriptLoaded()) === false) {
        console.log('Google Analytics script not fount');
        return;
      }

      if (!window['gtag']) {
        this.grabGtag();
      }

      const url = this.handleWrongLocationPath(window.location.href);
      console.log('url for Google Analytics', url);

      window['gtag']('event', 'page_view', {
        page_title: window.location.pathname,
        page_location: url,
        page_path: url,
      });
      console.log('Google Analytics trackPageView v2');
    } catch (e) {
      console.error('Google Analytics trackPageView v2 error', e);
    }
  }

  public static isScriptExist(): boolean {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      const src = scripts[i].getAttribute('src');
      if (src && src.includes('googletagmanager.com/gtag')) {
        return true;
      }
    }
    return false;
  }

  private static handleWrongLocationPath(url: string) {
    /**
     * https://itidigital.atlassian.net/jira/software/c/projects/DXP/boards/13?selectedIssue=DXP-1575
     
       Sometimes, Google Analytics records strange URL page visits, similar to the following
       the correct one looks like: http://visithighpoint.com/calendar/?imgoing-event=high-point-farmers-market-opening-day-65e76c660ce6ec59f5045937
       but sometimes it could be: http://visithighpoint.com/https://visithighpoint.com/calendar/?imgoing-event=high-point-farmers-market-opening-day-65e76c660ce6ec59f5045937?imgoing-event=high-point-farmers-market-opening-day-65e76c660ce6ec59f5045937
       or: http://visithighpoint.com/https:/visithighpoint.com/calendar/?someparames=123&imgoing-event=4s-5s-visit-all-a-flutter-butterfly-farm--6591ee7205c9a21ea6ef813c?imgoing-event=4s-5s-visit-all-a-flutter-butterfly-farm--6591ee7205c9a21ea6ef813c
    
       This method is to extract the correct part from such a URL
       */

    // Replace HTTP with HTTPS uniformly, and for the convenience of unified processing, replace all https:// with https:/, and replace back with https:// at the end of the method
    url = url.replace(/http:/g, 'https:').replace(/https:\/\//g, 'https:/');
    url = url.includes('/https') ? url.substring(url.indexOf('/https:')).substring(1) : url;

    const sp = url.split('?'); // new URLSearchParams(url);
    const newUrl = sp.splice(0, 2).join('?');

    return newUrl.replace('https:/', 'https://');
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/services/google.analytics.service.ts